export const CMS_CATEGORY_ID = 7882;
export const CMS_API = 'https://jx2.xoyo.com/api.php';

export const RESERVATION_URL = 'https://jx2.xoyo.com/p/zt/2026/09/17/new-server/index.html';
export const NEW_SERVER_URL = 'https://jx2.xoyo.com/p/zt/2026/09/21/ziliaopian/index.html';

export const TOPIC_ITEMS = [
  { key: 'treasure', title: '跨服夺宝，赛季争锋', articleId: 14744 },
  { key: 'weapon-soul', title: '兵魄拓境，武运精进', articleId: 14745 },
  { key: 'star-jade', title: '星玉焕新，战力腾跃', articleId: 14746 },
  { key: 'reservation', title: '华章共书，万侠登峰', url: RESERVATION_URL },
  { key: 'celebration', title: '金秋同庆，群侠共聚', articleId: 14747 },
  { key: 'new-server', title: '周年新服，再赴侠缘', url: NEW_SERVER_URL }
];

export const getTopicHref = item => (item.articleId ? `#/c/${item.articleId}` : item.url || undefined);

export const TOPIC_LINKS = TOPIC_ITEMS.map(item => {
  const href = getTopicHref(item);
  return {
    ...item,
    href,
    target: item.articleId ? undefined : '_blank',
    rel: item.articleId ? undefined : 'noopener',
    disabled: !href
  };
});

export const CELEBRATION_SECTIONS = [
  { key: 'mountain-river', title: '山河同庆会' },
  { key: 'lantern-night', title: '万家灯火照长夜' },
  { key: 'jade-rabbit', title: '玉兔闹月庭' },
  { key: 'moon-feast', title: '月满百味坊' },
  { key: 'travel-journal', title: '九州纪行册' },
  { key: 'treasure-box', title: '山河百炼彩匣' },
  { key: 'cornel-incense', title: '茱萸合香录' },
  { key: 'anniversary-gifts', title: '周年大赠送' },
  { key: 'anniversary-rewards', title: '周年大回馈' },
  { key: 'anniversary-surprise', title: '周年彩蛋' },
  { key: 'anniversary-pack', title: '周年礼包' },
  { key: 'decoration-exchange', title: '周年装饰兑换' },
  { key: 'recharge-lottery', title: '充值抽奖拼手气' },
  { key: 'festival-shop', title: '盛典欢乐购' },
  { key: 'meridian-pack', title: '特价脉气包' },
  { key: 'double-drops', title: '幸运双倍掉落' },
  { key: 'lucky-chest', title: '幸运百宝箱' },
  { key: 'heroes-gathering', title: '群侠共聚江湖' }
];
